import { render, staticRenderFns } from "./PGPayment_.vue?vue&type=template&id=53913a00&"
import script from "./PGPayment_.vue?vue&type=script&lang=js&"
export * from "./PGPayment_.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports